import { z } from "zod";
import { utcDatetime } from "../../../helpers/date";

export const OrganizationAccessTokenSchema = z.object({
    id: z.string().uuid(),
    tokenPrefix: z.string(),
    lastUsedAt: utcDatetime.nullable(),
    expiresAt: utcDatetime.nullable(),
    createdAt: utcDatetime,
});

export type OrganizationAccessToken = z.infer<
    typeof OrganizationAccessTokenSchema
>;

export const OrganizationAccessTokenPathParamsSchema = z.object({
    organizationId: z.string().uuid(),
});

export const GetOrganizationAccessTokenResponseSchema = z.object({
    token: OrganizationAccessTokenSchema.nullable(),
});

export type GetOrganizationAccessTokenResponse = z.infer<
    typeof GetOrganizationAccessTokenResponseSchema
>;

export const RotateOrganizationAccessTokenResponseSchema = z.object({
    token: OrganizationAccessTokenSchema,
    plaintext: z.string(),
});

export type RotateOrganizationAccessTokenResponse = z.infer<
    typeof RotateOrganizationAccessTokenResponseSchema
>;

export const OrganizationWebhookPortalResponseSchema = z.object({
    url: z.string().url(),
});

export type OrganizationWebhookPortalResponse = z.infer<
    typeof OrganizationWebhookPortalResponseSchema
>;
